module.exports = __webpack_public_path__ + "media/images/flags/4x3/irq-50d966387fd97f33760a6ca350bf252a.svg";